import AwardsInfo from './awards/awards';
import CertificateInfo from './certifications/certifications';
import EducationInfo from './education/education';
import WorkExperinceInfo from './work-experience/workExperience';
import TechProficiencyInfo from './techproficiency/techproficiency';
import _ from 'lodash';
const CandidateNavContentPane = ({ currentNavigation, candidateData }) => {
  if (!candidateData) {
    return <></>;
  }
  const { workExperience, educationalDetails } = candidateData;
  const currentRoles = _.get(workExperience, "currentRole", {}) || {}
  const previousRoles = _.get(workExperience, "previousJobs", []) || []
  const careerGaps = _.get(workExperience, "hasCareerGaps") === "YES"
    ? _.get(workExperience, "careerGaps", [])
    : [];

  switch (currentNavigation) {
    case 'experience':
      return <WorkExperinceInfo jobRoles={[currentRoles, ...previousRoles]} careerGaps={careerGaps} />;
    case 'education':
      return <EducationInfo education={educationalDetails} />;
    case 'certification':
      return <CertificateInfo certificateDocs={_.get(educationalDetails, 'otherCertificates')} />;
    case 'awards':
      return <AwardsInfo awardDocs={_.get(workExperience, 'awards')} />;
    case 'technical-proficiency':
      return <TechProficiencyInfo techproficiencyDocs={_.get(workExperience, 'techProficiencies')} />;
  }
};

export default CandidateNavContentPane;